fragment ShippingFragment on Shipping {
    id
    name
    status
    courier_id
    min_weight
    max_weight
    price
    countries
    updated_at
    created_at
}